<template lang="pug">
.v-detail-page.detail-page(v-if="data" :class="data.className ? data.className : ''")
	.detail-page__header
		h1.detail-page__title(v-if="data.title" ) {{ data.title }}
		button.detail-page__actions-btn.actions-btn(
			v-for="(action, index) in data.actions"
			:key="index"
			:title="action.text"
			@click="onShare(action.notification)")
			v-svg-icon.detail-page__actions-icons(icon="share")
	.detail-page__wrap
		.detail-page__left
			.detail-page__left-tags(v-if="data.topTags && data.topTags.length")
				.detail-page__left-tag(v-for="tag of data.topTags") {{tag}}
			v-detail-slider.detail-page__top-slider(v-if="data.topSlider" :data-source="data.topSlider")
			.detail-page__images(v-if="data.images" )
				img.detail-page__image.flc(
					v-for="(image, index) in data.images"
					:key="index"
					:src="image?.src"
					:alt="image?.alt")
			.detail-page__pictures(v-if="data.pictures")
				h5.detail-page__block-title(v-if="data.pictures.title") {{ data.pictures.title }}
				.detail-page__pictures-wrap(v-if="data.pictures.items" )
					img.detail-page__picture(
						v-for="(picture, index) in data.pictures.items"
						:key="index"
						:src="picture?.src"
						:alt="picture?.alt"
						:style="{width: `${100/data.pictures.items.length}%`}")
			.detail-page__review(v-if="data.review")
				h5.detail-page__block-title(v-if="data.review.title") {{ data.review.title }}
				v-modal-room-3d.detail-page__review(:data-source="data.review")
			.detail-page__right(v-if="isSm" )
				.detail-page__characteristics(v-if="data.characteristics && data.characteristics.items && data.characteristics.items.length" )
					.detail-page__subtitle-header
						h5.detail-page__subtitle(v-if="data.characteristics.title" ) {{ data.characteristics.title }}
						button.detail-page__compare-btn(:class="{'detail-page__compare-btn-disable': compareStatus}" @click="toggleCompareStatus")
							span {{ !compareStatus ? data.compareTitleEmpty : data.compareTitle }}
							v-svg-icon.detail-page__compare-icon(icon="compare")
					.detail-page__separator
					transition(name="collapse" )
						.detail-page__characteristics-item(v-if="data.characteristics.items" )
							.detail-page__characteristics-item.flc(v-for="(item, index) in data.characteristics.items" :key="index")
								.detail-page__characteristics-name(v-if="item.name" ) {{ item.name }}
								.detail-page__characteristics-text(v-if="item.text" ) {{ item.text }}
								.product__offers(v-if="item.collections && item.collections.length")
									template(v-for="(item, index) in item.collections" :key="index" )
										.product__offers-item
											a.offer-item(:class="{'offer-item--active' : item.active}" :href="item.link")
												.offers-item__img(v-if="item.preview" :style="{backgroundColor: item.preview}" )
					a.detail-page__show-all.show-all(v-if="data.characteristics.button" href="#characteristics")
						.show-all__inner
							| {{ data.characteristics.button?.text }}
						.show-all__line
					.detail-page__product-features
						.detail-page__product-features-item(v-for="(item, index) of data.features" :key="index")
							img.detail-page__product-features-icon(:src="item.icon")
							span.detail-page__product-features-text {{item.text}}
				.detail-page__video(v-if="data.video")
					v-video(:src="data.video?.src")
				.detail-page__more(v-if="data.more" )
					a.detail-page__more-link-wrap(v-if="data.more.href" :href="data.more.href")
						h5.detail-page__subtitle(v-if="data.more.title" ) {{ data.more.title }}
						v-svg-icon.detail-page__more-icon(icon="back")
					.detail-page__separator
					.detail-page__more-items(v-if="data.more.items")
						transition-group(name="dropdown" )
							v-detail-aside-card.detail-page__more-item(
								v-for="(item, index) in computedShowedItems"
								:key="index"
								:data-source="item" )
					button.detail-page__show-all.show-all(
							v-if="data.more.button && data.more.items.length > visibleItems"
							type="button"
							@click="isMoreOpenFull = !isMoreOpenFull")
						.show-all__inner
							| {{ isMoreOpenFull ? data.more.button?.hideText : data.more.button?.showText }}
							v-svg-icon.icon-show-all(:class="{'rotate180': isMoreOpenFull}" icon="chevron-down-sm")
						.show-all__line
				.detail-page__actions(:class="{'show-btns': isButtonsVisible}" )
					.detail-page__buttons(v-if="data.buttons" )
						button.detail-page__button.btn(
							v-for="(button, index) in data.buttons"
							@click="handleClick(button.event)"
							:key="index")
							|{{ button.text }}
					.detail-page__links(v-if="data.links" )
						a.detail-page__link.btn--transparent(
							v-for="(link, index) in data.links"
							:key="index"
							:href="link?.href")
							|{{ link.text }}

			.detail-page__info(v-if="data.info" id="characteristics")
				.detail-page__infoblock.flc(v-for="(infoblock, index) in data.info" :key="index" )
					h5.detail-page__subtitle(v-if="infoblock.title" ) {{ infoblock.title }}
					.detail-page__separator
					template(v-if="infoblock.type === 'list'" )
						ul.detail-page__infoblock-list(v-if="infoblock.items" )
							li.detail-page__infoblock-list-item.flc(v-for="(item, index) in infoblock.items" :key="index")
								span {{ item }}
					template(v-if="infoblock.type === 'html'" )
						.detail-page__infoblock-content(v-if="infoblock.content" v-html="infoblock.content" )
					template(v-if="infoblock.type === 'options'" )
						ul.detail-page__infoblock-options(v-if="infoblock.items" )
							li.detail-page__infoblock-options-item.flc(
									v-for="(item, index) in infoblock.items"
									:key="index")
								.detail-page__infoblock-options-name(v-if="item.name" ) {{ item.name }}
								component.detail-page__infoblock-options-text(v-if="item.text"
										:is="item.link ? 'a' : 'div'"
										:href="item.link || undefined")
										| {{ item.text }}
					template(v-if="infoblock.type === 'image'" )
						img.detail-page__infoblock-image(
							v-if="infoblock.image"
							:src="infoblock.image?.src"
							:alt="infoblock.image?.alt")
					template(v-if="infoblock.type === 'documents'" )
						template(v-if="infoblock.documents")
							.detail-page__infoblock-document(v-for="(document, index) in infoblock.documents" :key="index" )
								.detail-page__infoblock-document-wrap
									.detail-page__infoblock-document-icon
										v-svg-icon.icon-folder(icon="folder")
									.detail-page__infoblock-document-title
										.detail-page__infoblock-document-name(v-if="document.name" ) {{ document.name }}
										.detail-page__infoblock-document-info
											span.detail-page__infoblock-document-type(v-if="document.type" ) {{ document.type }}
											span.detail-page__infoblock-separator |
											span.detail-page__infoblock-document-size(v-if="document.size" ) {{ document.size }}
								a.detail-page__infoblock-document-link(
										v-if="document.link"
										:href="document.link?.href"
										download)
									| {{ document.link?.text }}

		.detail-page__right.detail-page__aside(v-if="!isSm" )
			.detail-page__right-wrap
				.detail-page__characteristics(v-if="data.characteristics && data.characteristics.items && data.characteristics.items.length" )
					.detail-page__subtitle-header
						h5.detail-page__subtitle(v-if="data.characteristics.title" ) {{ data.characteristics.title }}
						button.detail-page__compare-btn(:class="{'detail-page__compare-btn-disable': compareStatus}" @click="toggleCompareStatus")
							span {{ !compareStatus ? data.compareTitleEmpty : data.compareTitle }}
							v-svg-icon.detail-page__compare-icon(icon="compare")
					.detail-page__separator
					.detail-page__characteristics-item(v-if="data.characteristics.items" )
						.detail-page__characteristics-item.flc(v-for="(item, index) in data.characteristics.items" :key="index")
							.detail-page__characteristics-name(v-if="item.name" ) {{ item.name }}
							.detail-page__characteristics-text(v-if="item.text" ) {{ item.text }}
							.detail-page__offers(v-if="item.collections && item.collections.length")
								template(v-for="(item, index) in item.collections" :key="index" )
									.detail-page__offers-item
										a.offer-item(:class="{'offer-item--active' : item.active}" :href="item.link")
											.offers-item__img(v-if="item.preview" :style="{backgroundColor: item.preview}" )
					a.detail-page__show-all.show-all(v-if="data.characteristics.button" href="#characteristics")
						.show-all__inner
							| {{ data.characteristics.button?.text }}
						.show-all__line
					.detail-page__product-features
						.detail-page__product-features-item(v-for="(item, index) of data.features" :key="index")
							img.detail-page__product-features-icon(:src="item.icon")
							span.detail-page__product-features-text {{item.text}}
				.detail-page__actions
					.detail-page__buttons(v-if="data.buttons" )
						button.detail-page__button.btn(
							v-for="(button, index) in data.buttons"
							@click="handleClick(button.event)"
							:key="index")
							|{{ button.text }}
					.detail-page__links(v-if="data.links" )
						a.detail-page__link.btn--transparent(
							v-for="(link, index) in data.links"
							:key="index"
							:href="link?.href")
							|{{ link.text }}
				.detail-page__video(v-if="data.video")
					v-video(:src="data.video?.src")
				.detail-page__more(v-if="data.more" )
					a.detail-page__more-link-wrap(v-if="data.more.href" :href="data.more.href")
						h5.detail-page__subtitle(v-if="data.more.title" ) {{ data.more.title }}
						v-svg-icon.detail-page__more-icon(icon="back")
					.detail-page__separator
					.detail-page__more-items(v-if="data.more.items")
						transition-group(name="dropdown" )
							v-detail-aside-card.detail-page__more-item.flc(
								v-for="(item, index) in computedShowedItems"
								:key="index"
								:data-source="item" )
					button.detail-page__show-all.show-all(
						v-if="data.more.button && data.more.items.length > visibleItems"
						type="button"
						@click="isMoreOpenFull = !isMoreOpenFull")
						.show-all__inner
							| {{ isMoreOpenFull ? data.more.button?.hideText : data.more.button?.showText }}
							v-svg-icon.icon-show-all(:class="{'rotate180': isMoreOpenFull}" icon="chevron-down-sm")
						.show-all__line
			// обернуть верхние 4 блока в этот класс, если нужно будет вернуться к возможности скроллить
			//.detail-page__right-inner.scrollbar

	.detail-page__bottom-slider(v-if="$slots['features-slider']")
		slot(name="features-slider")
	.detail-page__calculator-section(v-if="$slots['calculator']" v-memo="[data]")
		slot(name="calculator")

	.contacts-page__aside-modal
		transition(name="show-aside")
			.aside-modal(v-if="asideOpen ")
				.aside-modal__overlay(@click.stop="closeForm")
				.aside-modal__inner.scrollbar
					.aside-modal__body
						button.aside-modal__close(@click.stop="closeForm")
							v-svg-icon.aside-modal__close-icon(icon="cross")
						template(v-if="$slots['feedback-form']")
							slot(name="feedback-form")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import scrollLock from "scroll-lock";
import controller from "../scripts/controller/controller.js";
import VSvgIcon from "/local/assets/source/components/helpers/v-svg-icon.vue";
import { mapActions, mapGetters } from 'vuex';

export default {
	components: {VSvgIcon},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			isMoreOpenFull: false,
			isButtonsVisible: false,
			asideOpen: false,
			visibleItems: 6,
			compareStatus: false,
			compareItems: []
		}
	},

	mounted () {
		this.$store.dispatch('compare/request', {})

		setTimeout(() => {
			this.compareStatus = this.$store.state.compare.items.some(item => item.id == this.data.id);
		}, 500)
	},

	methods: {
		...mapActions('compare', ['add', 'remove']),

		dataSet(data) {
			this.data = data;

			this.$nextTick(() => {
				if(!this.isSm) {
					// gsap.to(".detail-page__aside", {
					// 	scrollTrigger: {
					// 		trigger: '.detail-page__aside',
					// 		start: 'bottom 95%',
					// 		endTrigger: '.detail-page__left',
					// 		end: 'bottom 95%',
					// 		scrub: true,
					// 		markers: true,
					// 		pin: '.detail-page__aside',
					// 	},
					// });
				}
			})
		},

		setActiveProduct(id) {
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					collectionId: id,
				}
			});
		},

		handleScroll() {
			this.isButtonsVisible = window.scrollY > 1300;
		},

		showForm() {
			this.asideOpen = true;
			scrollLock.enablePageScroll();
			scrollLock.disablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},

		closeForm() {
			this.asideOpen = false;
			scrollLock.enablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},

		handleClick(event) {
			switch (event) {
				case 'form':
					this.showForm();
					break
			}
		},

		onShare(notification) {
			if (this.isXs) {
				navigator.share({
					title: this.data.title,
					url: window.location.href
				})
			} else {
				navigator.clipboard.writeText(window.location.href);
				controller.addNotification(notification);
			}
		},

		async toggleCompareStatus() {
			if (!this.data?.id) return;

			const itemId = this.data.id;

			if (this.compareStatus) {
				// this.$store.commit('compare/removeItem', itemId)
				this.$store.dispatch('compare/remove', [itemId]);
			} else {
				// this.$store.commit('compare/addItem', itemId)
				this.$store.dispatch('compare/add', [itemId]);
			}

			this.compareStatus = !this.compareStatus;
		},
	},

	computed: {
		...mapGetters('compare', ['compareCountByItem']),

		computedShowedItems() {
			if(this.data.more.items && this.data.more.items.length) {
				return this.isMoreOpenFull ? this.data.more.items : this.data.more.items.slice(0, this.visibleItems)
			}
		},

		compareCount() {
			return this.$store.getters['compare/compareCount'];
		}
	},

	created() {
		window.addEventListener('scroll', this.handleScroll);
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
}

</script>